import { ActivatedRoute, Router } from '@angular/router';
import { Authenticationservice } from './../../services/authentication.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-docforcredit',
  templateUrl: './docforcredit.component.html',
  styleUrls: ['./docforcredit.component.css']
})
export class DocforcreditComponent implements OnInit {

  zone: string;

  constructor(private auth: Authenticationservice, private route: ActivatedRoute) {
    let userdata;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;

    const date = new Date()
    const result = date.toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })

    this.today = result;
  }

  takedata = [];
  today: string;
  year: string;
  ngOnInit(): void {
    this.year = this.route.snapshot.paramMap.get('year');
    console.log('history;', history);
    //this.takedata = history.state.fmcode;
    let data = localStorage.getItem('fmcodedataforcredit');
    this.takedata = JSON.parse(data);
    setTimeout(() => {
      window.print();
    }, 3000);
  }

  THtoLocal(thisdate: string) {
    if (!thisdate) { return ''; }
    const date1 = new Date(thisdate);
    let options: any = {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: 'UTC',
    };
    return date1.toLocaleString('th-TH', options);
  }

}
